const label = "_label_29jkz_1";
const styles = {
  label
};
export {
  styles as default,
  label
};
//# sourceMappingURL=Label.module.scss.js.map
